import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './fr.json';
import en from './en.json';
import de from './de.json';

const savedLang = localStorage.getItem('i18n_language');

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      de: { translation: de },
    },
    lng: savedLang || 'fr',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
  });

document.documentElement.lang = savedLang || 'fr';
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
